import Box from "@mui/material/Box";
import { StyledLink } from "../../AppNavigation/StyledLink";
import { useAppSelector } from "../../../redux/hooks";
import { UNIVERSAL_STORE_SITE } from "@brandclub/common-ui";
import React from "react";

export const BrandclubTermsAndConditions = ({
  sx,
}: {
  sx?: React.ComponentProps<typeof Box>["sx"];
}) => {
  const domainConfig = useAppSelector(
    ({ appConfig }) => appConfig?.domainConfig
  );
  const linkPrefix =
    domainConfig?.storeBrandingType === "CustomDTCStore"
      ? UNIVERSAL_STORE_SITE
      : "";

  return (
    <Box
      component="p"
      sx={{
        fontSize: 14,
        fontWeight: 500,
        marginTop: 4,
        color: 'text.primary',
        textAlign: 'center',
        opacity: 0.3,
        ...sx,
      }}
    >
      {`By continuing, I agree to the `}
      <StyledLink to={linkPrefix + '/terms'} target="_blank">
        Terms of Service
      </StyledLink>{' '}
      ,{' '}
      <StyledLink to={linkPrefix + '/privacy'} target="_blank">
        Privacy Policy
      </StyledLink>
      {' and to receive text messages. Message and data rates may apply. Reply stop to opt out.'}
    </Box>
  );
};
